// Core
import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Flex, Button, Select, Box, Image, Grid, Text, Switch, Spinner, useDisclosure } from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';
import { textLang } from 'services/Lang';

// Components
import DeleteModal from './DeleteModal';
import LogoutModal from './LogoutModal';

const Settigns = ({isCheckedTypeAccount, setIsCheckedTypeAccount, object, refetchUser}) => {
	const { isOpen, onClose, onOpen } = useDisclosure();
	const { isOpen: isOpenLogout, onClose: onCloseLogout, onOpen: onOpenLogout } = useDisclosure();

	const handleToggle = () => {
		const newValue = !isCheckedTypeAccount;
		setIsCheckedTypeAccount(newValue);
		localStorage.setItem('switchAccountType', JSON.stringify(newValue));
	};

	const history = useHistory();
	const handleDeleteAccount = async () => {
		const response = await apiService.deleteMe();
		if(response.statusCode === 200){
			localStorage.removeItem('auth');
			localStorage.removeItem('switchAccountType'); 
		    history.push('/auth/sign-up'); 
		}
	};

	const handleLogoutAccount = async () => {
		localStorage.removeItem('auth');
		localStorage.removeItem('switchAccountType'); 
	    history.push('/auth/sign-up'); 
	};

	const [switched, setSwitched] = useState(object?.isHidden);
	const handleHidden = (event) => {
	    const newSwitched = !switched;
	    setSwitched(newSwitched);
	    if(object) {
	      try {
	        apiService.updateMe({ id: object.id, isHidden: newSwitched });  
	        refetchUser();
	      } catch (e){
	        console.log(e);
	      }
	    }
	};

	const currentLang = localStorage.getItem('lang') || 'en';

	const handleChange = (e) => {
	    const lang = e.target.value;
	    localStorage.setItem('lang', lang);
	    window.location.href = '/';
	};

	return (
		<Box 
			maxH="100vh" 
			pt="16px" 
			pb="350px" 
			overflowY="auto">
			<Box bg="white" p="20px" borderRadius="16px">
			    <Flex alignItems="center" justifyContent="space-between">
					<Box w="80%">
						<Text>{textLang('setting_hidden_header')}</Text>
						<Text variant="text-xs" mt="8px" color="#444">
							{textLang('setting_hidden_text')}
						</Text>
					</Box>
					<Switch 
						className="switch"
						isChecked={switched}
            			onChange={handleHidden}
						/>
				</Flex>
			</Box>

			<Select
				mt="16px"
				className="change-lang-profile"
		      defaultValue={currentLang}
		      onChange={handleChange}
		    >
		      <option value="en">English 🇬🇧</option>
		      <option value="ru">Русский 🇷🇺</option>
			</Select>

    		<Button onClick={onOpenLogout} variant="secondary-md" borderRadius="full" px="16px !important" mt="16px">
	        	<Text as="span" pl="12px" color="white">{textLang('setting_modal_logout')}</Text>
	    	</Button>

			<Button variant="solid-md" borderRadius="full" px="16px !important" mt="16px">
        		<Text as="span" pl="12px" onClick={onOpen}>{textLang('setting_modal_delete')}</Text>
    		</Button>

    		<DeleteModal
			  handle={handleDeleteAccount}
			  isOpen={isOpen}
			  onClose={onClose}
			/>

			<LogoutModal
			  handle={handleLogoutAccount}
			  isOpen={isOpenLogout}
			  onClose={onCloseLogout}
			/>

    		<Button as="a" target='_blank' href="https://klkilabs.org/megameet-privacy-policy.html" variant="solid-md" borderRadius="full" px="16px !important" mt="16px">
        		<Text as="span" pl="12px">Privacy policy</Text>
	    	</Button>

			<Button as="a" target='_blank' href="https://klkilabs.org/megameet-terms-and-conditions.html" variant="solid-md" borderRadius="full" px="16px !important" mt="16px">
        		<Text as="span" pl="12px">Terms and conditions</Text>
	    	</Button>


		</Box>
	);
};

export default Settigns;